<template>
  <div id="register-setting-page">
    <div class="page-name">
      <div class="page-title">Setup Grand Unity Family</div>
    </div>
    <div class="page-container">
      <b-card class="w-100">
        <gu-family-banner-table
          :data="banner"
          :paginate="paginate"
          :onSetActive="onSetActive"
          :onCreateData="onCreateData"
          :onUpdateData="onUpdateData"
          :onDeleteData="onDeleteData"
          :onUpdatePaginate="onUpdatePaginate"
          :onUpdateLimit="onUpdateLimit"
          :onUpdateSort="onUpdateSort"
          :onSetOpenNewWindow="onSetOpenNewWindow"
          :onRefresh="(e) => fetchList(this.paginate.page)"
        />
      </b-card>
      <br />
    </div>
  </div>
</template>

<script>
import GuFamilyBannerTable from '@/components/tables/GuFamilyBannerTable'
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'

export default {
  components: {
    'gu-family-banner-table': GuFamilyBannerTable,
  },
  data: () => ({
    enable: true,
    banner: [],
    paginate: {
      limit: 10,
      page: 1,
      totalPage: 1,
      totalRow: '',
    },
  }),
  methods: {
    ...mapActions({
      getList: ActionFetch.GUFAMILY.BANNER.LIST,
      createData: ActionFetch.GUFAMILY.BANNER.CREATE,
      updateData: ActionFetch.GUFAMILY.BANNER.UPDATE,
      updateSort: ActionFetch.GUFAMILY.BANNER.UPDATESORT,
      deleteData: ActionFetch.GUFAMILY.BANNER.DELETE,
    }),
    onUpdatePaginate($paginate) {
      this.paginate.page = $paginate

      this.fetchList($paginate)
    },
    onCreateData($data) {
      let dataSave = Object.assign({}, $data)

      this.createData(dataSave).then(($res) => {
        this.fetchList()
      })
    },
    onUpdateData($data) {
      let dataSave = Object.assign({}, $data)

      this.updateData(dataSave).then(($res) => {
        if ($res.success) {
          this.fetchList()
        }
      })
    },
    onDeleteData($data) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure ?`, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0 justify-center',
          centered: true,
          okOnly: true,
        })
        .then(($conRes) => {
          if ($conRes) {
            this.deleteData($data.id).then(($res) => {
              if ($res.success) {
                this.fetchList(this.paginate.page)
              }
            })
          }
        })
    },
    onUpdateSort($data) {
      this.updateSort($data).then(($res) => {
        if ($res.success) {
          this.fetchList(this.paginate.page)
        }
      })
    },
    onUpdateLimit($limit) {
      this.paginate.limit = $limit
      this.paginate.page = 1

      this.fetchList()
    },
    onSetActive($data, $source) {
      $source.status = $data.value ? 'Active' : 'Inactive'

      let dataSave = {
        id: $source.id,
        status: $source.status,
      }

      this.updateData(dataSave)
    },
    onSetOpenNewWindow($data, $source) {
      $source.isOpenNewWindow = $data.value ? 'Y' : 'N'

      let dataSave = {
        id: $source.id,
        isOpenNewWindow: $source.isOpenNewWindow,
      }

      this.updateData(dataSave)
    },
    fetchList($page = 1) {
      const payload = {
        orderBy: 'orderNum',
        direction: 'asc',
        limit: this.paginate.limit,
        page: $page,
      }

      this.getList(payload).then(($res) => {
        if ($res.success) {
          this.banner = $res.data.map(($data) => {
            if ($data.endDate) {
              const endDate = new Date($data.endDate)
              let dd = endDate.getDate()
              let mm = endDate.getMonth() + 1
              let yy = endDate.getFullYear()
              const currentEndDate = new Date(`${yy}-${mm}-${dd} 23:59:59`)
              const currentDate = new Date()

              if (currentEndDate < currentDate) {
                $data.status = 'Inactive'
              }
            }

            return $data
          })
          this.paginate.totalPage = $res.dataLimit
            ? $res.dataLimit.totalPage
            : 1
          this.paginate.totalRow = $res.dataLimit ? $res.dataLimit.totalData : 0
        }
      })
    },
  },
  created() {
    this.fetchList()
  },
}
</script>

<style>
td {
  vertical-align: middle !important;
  font-size: 14px;
}
</style>
